import React from 'react';

import cn from 'classnames';
import { omit } from 'lodash';
import { string, node, shape } from 'prop-types';

import Paper from '@mui/material/Paper';

import { withMenuOnClickContainer } from 'containers/withMenu';

import v from 'components/variables';

import s from './SideNavWrapper.css';

@withMenuOnClickContainer
export default class Wrapper extends React.Component {
  render() {
    const { color, children, className, style, ...internal } = this.props;

    const { visibleMenu, setMenu, hideMenu, ...restProps } = internal;

    return (
      <Paper
        data-sidenav="1"
        style={{
          background: v[`${color}XtraDark`],
          ...style,
        }}
        className={cn(s.sideNav, className)}
        {...omit(restProps, [
          'staticContext',
          'dispatch',
          'router',
          'moduleAccess',
          'sideNav',
        ])}
      >
        {React.Children.map(children, child =>
          !child || !child.type
            ? child
            : React.cloneElement(child, {
                visibleMenu,
                setMenu,
                hideMenu,
              }),
        )}
        {visibleMenu}
      </Paper>
    );
  }
}

Wrapper.propTypes = {
  color: string,
  children: node,

  style: shape({}),
  className: string,
};

Wrapper.defaultProps = {
  color: 'green',
  children: undefined,

  style: {},
  className: undefined,
};
